import { Each } from "../../common/Each"
import { FeedbackQuestionType, FeedbackType } from "../../common/constants"
import styles from "./FeedbackViewer.module.css"
import { formatDateV2, formatTimeV2 } from "../../utils"


const FeedbackViewer = ({ userFeedback, feedback }) => {
    if (!userFeedback || !feedback) return null


	const getColor = (n) => {
		if (!n)
			return "var(--sf-gray)"

		if (n < 2.5) {
			return "var(--sf-red)"
		}
		if (n < 4) {
			return "var(--sf-yellow)"
		}
		if (n >= 4)
			return "var(--sf-green)"
	}

	return (
		<div className={styles.container}>
			{
				feedback.resource_type === FeedbackType.Lesson &&
				<>
					<Each
						of={userFeedback.feedbacks}
						render={(uf, i) => (
							<div className={styles.feedback}>
								<div className={styles.header}>
									<div className={styles.lesson}>{uf.lesson?.name || "Lezione"}</div>
									<div className={styles.course}>{uf.course?.name} · {uf.edition?.name}</div>
									<div className={styles.date}>{formatDateV2(uf.updated_at ?? uf.created_at, {day: '2-digit', month: '2-digit', year: 'numeric'})} - {formatTimeV2(uf.updated_at ?? uf.created_at)}</div>
								</div>
								<Each
									of={uf.content}
									render={item => (
										<div className={styles.questions}>
											{
												[FeedbackQuestionType.Quantitative, FeedbackQuestionType.Qualitative].includes(item.type) &&
												<div className={styles.numeric}>
													<div className={styles.question}>{item.question}</div>
													<div className={`${styles.roundBadge} ${styles.small}`} style={{ "--accent-color": getColor(item.answer) }}>{item.answer ?? "—"}</div>
												</div>
											}
											{
												item.type === FeedbackQuestionType.Open &&
												<div className={styles.open}>
													<div className={styles.question}>{item.question}</div>
													<div className={styles.answer}>{item.answer ?? "—"}</div>
												</div>
											}
										</div>
									)}
								/>
							</div>
						)}
					/>
				</>
			}
			{
				feedback.resource_type === FeedbackType.Course &&
				<>
					<div className={styles.description}>{feedback.description}</div>
					<Each
						of={userFeedback.feedback.content}
						render={item => (
							<>
								{
									[FeedbackQuestionType.Quantitative, FeedbackQuestionType.Qualitative].includes(item.type) &&
									<div className={styles.numeric}>
										<div className={styles.question}>{item.question}</div>
										<div className={`${styles.roundBadge} ${styles.small}`} style={{ "--accent-color": getColor(item.answer) }}>{item.answer ?? "—"}</div>
									</div>
								}
								{
									item.type === FeedbackQuestionType.Open &&
									<div className={styles.open}>
										<div className={styles.question}>{item.question}</div>
										<div className={styles.answer}>{item.answer ?? "—"}</div>
									</div>
								}
							</>
						)}
					/>
				</>
			}

		</div>
	)
}

export default FeedbackViewer